export enum UserSignupMethod {
	Normal = 0,
	AdminCreated = 10,
	Facebook = 20,
	Google = 30
}